import React from 'react';

function GroupifyProblem() {
    return(
        <section className="sunney-problem">
        <h2>Context & Problem</h2>
        <h3>The Problem Statement</h3>
        <p>
        International and first-generation students at large urban universities like Northeastern often face <strong>social isolation</strong>. 
        Barriers such as <strong>"family achievement guilt"</strong>, <strong>cultural differences</strong>, and the <strong>rigor of experiential learning</strong> make forming 
        long-lasting relationships daunting. Students struggle to find meaningful connections while balancing academic demands and 
        navigating unfamiliar social environments.
        </p>
        <h3>The Goal</h3>
        <p>
        To improve <strong>"belongingness"</strong> by providing a platform for <strong>low-stakes, spontaneous social engagement</strong> that fits within a 
        <strong>rigid academic schedule</strong>. The solution needed to remove barriers to social connection while respecting students' time 
        constraints and need for flexibility.
        </p>
    </section>
    );
}

export default GroupifyProblem;
